import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <header className="mx-auto max-w-3xl text-center" data-id="element-274" data-mp="3k06xfwc3ovzb">
      {kicker && <p className={`font-display text-lg font-bold uppercase tracking-wider ${isDark ? 'text-electric-400' : 'text-electric-600'}`} data-id="element-275" data-mp="3k29kc7hyi8zt">
          {kicker}
        </p>}
      <h2 className={`mt-2 font-display text-[38px] font-extrabold uppercase leading-[0.98] sm:text-5xl lg:text-6xl ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-276" data-mp="1uk3sc1zaxbw">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-[17px] leading-relaxed ${isDark ? 'text-slate-300' : 'text-muted'}`} data-id="element-277" data-mp="ui6iafcqvmdj">{subtitle}</p>}
    </header>;
}